<input
  matInput
  [id]="id"
  [attr.data-test]="id"
  [errorStateMatcher]="errorStateMatcher"
  [formControl]="formControl"
  [matDatepicker]="picker"
  [matDatepickerFilter]="$any(props.datepickerOptions?.filter)"
  [max]="max"
  [min]="min"
  [formlyAttributes]="field"
  [placeholder]="props.placeholder || defaultPlaceholder"
  [tabindex]="props.tabindex"
  [readonly]="props.readonly"
  [required]="required"
  (dateInput)="props.datepickerOptions?.dateInput(field, $event)"
  (dateChange)="props.datepickerOptions?.dateChange(field, $event)"
  [luiDatepickerMask]="defaultMask"
  #input
/>
<ng-template #datepickerToggle>
  <mat-datepicker-toggle
    (click)="detectChanges()"
    [disabled]="props.disabled"
    [for]="picker"
  >
    <mat-icon matDatepickerToggleIcon svgIcon="calendar"> </mat-icon
  ></mat-datepicker-toggle>
</ng-template>
<mat-datepicker
  #picker
  [color]="props.color"
  [dateClass]="$any(props.datepickerOptions?.dateClass)"
  [disabled]="props.datepickerOptions?.disabled"
  [opened]="props.datepickerOptions?.opened"
  [panelClass]="props.datepickerOptions?.panelClass || ''"
  [startAt]="props.datepickerOptions?.startAt"
  [startView]="$any(props.datepickerOptions?.startView)"
  [touchUi]="props.datepickerOptions?.touchUi"
  [calendarHeaderComponent]="
    $any(props.datepickerOptions).calendarHeaderComponent
  "
  (monthSelected)="
    $any(props.datepickerOptions).monthSelected(field, $event, picker)
  "
  (yearSelected)="props.datepickerOptions?.yearSelected(field, $event, picker)"
  (opened)="$any(props.datepickerOptions).opened = true"
  (closed)="$any(props.datepickerOptions).opened = false"
>
</mat-datepicker>
